import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { EChartOption } from "echarts";
// import { AngularFontAwesomeComponent } from 'angular-font-awesome';
@Component({
  selector: "app-monthly-reviews-goal",
  templateUrl: "./monthly-reviews-goal.component.html",
  styleUrls: ["./monthly-reviews-goal.component.scss"],
})
export class MonthlyReviewsGoalComponent implements OnInit {
  public loading = false;
  team_member_review_requests: {
    name: string;
    value: number;
    count: string;
  }[] = [];
  chartOption: EChartOption;
  private _analyticsData: any;
  @Input()
  set analyticsData(value) {
    this._analyticsData = value;
  }
  get analyticsData() {
    return this._analyticsData;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.analyticsData &&
      changes.analyticsData.currentValue !== undefined
    ) {
      let analyticsData = changes.analyticsData.currentValue;
      this.analyticsData = analyticsData;
      this.getInvitesByTeamMember();
    }
  }
  constructor() {}

  ngOnInit() {
    this.loading = true;
    this.getInvitesByTeamMember();
  }
  getInvitesByTeamMember() {
    this.team_member_review_requests = this.analyticsData[
      "team_member_review_requests"
    ].map((e) => {
      return {
        name: e.first_name + " " + e.last_name,
        value: e.review_request_count,
        count: e.followed_count,
      };
    });
    this.team_member_review_requests.sort(function (a, b) {
      return b.value - a.value;
    });
    var colorPalette = [
      "#27beb6",
      "#518bc9",
      "#94cae3",
      "#f391bc",
      "#915ba6",
      "#8b8bc3",
      "#A43820",
      "#375E97",
      "#FFBB00",
      "#F18D9E",
      "#E4EA8C",
      "#98DBC6",
      "#5BC8AC",
    ];

    this.chartOption = {
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          // console.log(params);

          return `${params["data"].name} : ${params["data"].count} /  ${params["data"].value} <br />
                  `;
        },
      },
      toolbox: {
        show: true,
        feature: {
          mark: { show: true },
          dataView: { show: false, readOnly: false },
          magicType: {
            show: true,
            type: ["pie", "funnel"],
            option: {
              funnel: {
                x: "25%",
                width: "50%",
                funnelAlign: "center",
                max: 1548,
              },
            },
          },
        },
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["55%", "80%"],
          avoidLabelOverlap: true,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "inside",
                formatter: function (params) {
                  return params.value + "\n";
                },
              },
              labelLine: {
                show: false,
              },
            },
            emphasis: {
              label: {
                show: true,
                position: "center",
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold",
                },
              },
            },
          },
          data: this.team_member_review_requests,
        },
      ],
      color: colorPalette,
    };
    this.loading = false;
  }
}
